(() => {
  'use strict';
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const unknown = 'To be confirmed';
  function validDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const parsed = new Date(value + 'T12:00:00Z');
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
  }
  function calendarDate(value) {
    const match = String(value).match(/^([A-Za-z]+) ([0-9]{1,2}), ([0-9]{4})$/);
    if (!match || !months.includes(match[1])) return null;
    const iso = match[3] + '-' + String(months.indexOf(match[1]) + 1).padStart(2, '0') + '-' + match[2].padStart(2, '0');
    return validDate(iso) ? iso : null;
  }
  function formattedDate(value) {
    return validDate(value) ? months[Number(value.slice(5, 7)) - 1] + ' ' + Number(value.slice(8, 10)) + ', ' + value.slice(0, 4) : unknown;
  }
  function resolveDates(text, projection, variantId) {
    const normalized = String(text || '').replace(/\s+/g, ' ').trim();
    const part = '(To be confirmed|[A-Za-z]+ [0-9]{1,2}, [0-9]{4})';
    const match = normalized.match(new RegExp('^Release Date: ' + part + '\\. Estimated Shipping Date: ' + part + '\\.$'));
    if (match && (match[1] === unknown || calendarDate(match[1])) && (match[2] === unknown || calendarDate(match[2]))) return [match[1], match[2]];
    if (normalized === 'Estimated Shipping Date: To be confirmed.') return [unknown, unknown];
    if (projection?.enabled !== true) return null;
    const variant = projection.variants?.find(row => String(row.id) === String(variantId));
    if (!variant) return null;
    const releaseDate = variant.releaseDate || projection.releaseDate;
    if (validDate(projection.sourceReleaseDate) && validDate(releaseDate) && projection.sourceReleaseDate !== releaseDate) return [unknown, unknown];
    return [formattedDate(releaseDate), formattedDate(variant.shippingDate || projection.shippingDate)];
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { validDate, calendarDate, formattedDate, resolveDates };
    return;
  }
  if (window.PMVPreorderDatesLayout || !document.body.classList.contains('template-product')) return;
  let guard, copy;
  try {
    guard = JSON.parse(document.getElementById('pmv-preorder-guard-bootstrap').textContent);
    copy = JSON.parse(document.getElementById('pmv-preorder-policy-copy').textContent);
  } catch (_) { return; }
  const productVariants = new Set((guard.initial?.productVariants || []).map(row => String(row.variantId || '').split('/').pop()).filter(value => /^[0-9]+$/.test(value)));
  if (guard.initial?.schema !== 1 || !productVariants.size) return;
  function selectedProductVariant(context) {
    const forms = context?.querySelectorAll('.product__buy-buttons > product-form > form[data-type="add-to-cart-form"]');
    if (forms?.length !== 1) return null;
    const inputs = forms[0].querySelectorAll('input[name="id"]');
    return inputs.length === 1 ? String(inputs[0].value || '') : null;
  }
  function matchesProduct(card) {
    const context = card.closest('.product__info-container');
    const selected = selectedProductVariant(context);
    return selected !== null && productVariants.has(selected) &&
      (!card.matches('[data-pmv-stoq-info]') || card.dataset.variantId === selected);
  }
  if (![copy.releaseLabel, copy.shippingLabel].every(value => typeof value === 'string' && value.trim())) return;
  const root = document.getElementById('MainContent');
  if (!root) return;
  const selector = '.product__info-container .restock-rocket-preorder-description, .product__info-container .pmv-stoq-reserved[data-pmv-stoq-info]';
  const marker = 'data-pmv-dates-ready';
  const owned = '[data-pmv-preorder-dates]';
  const presentations = owned + ', [data-pmv-preorder-policy]';
  const records = new Map();
  const information = new Map();
  const informationForms = new Set();
  const informationProperty = 'data-pmv-preorder-information-property';
  let frame = 0, stopped = false;

  function visible(element) {
    if (!element || !element.getClientRects().length) return false;
    for (let node = element; node && node.nodeType === 1; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' || style.display === 'none' ||
          style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  }
  function originalVisible(card, source) {
    const marked = card.hasAttribute(marker);
    if (marked) card.removeAttribute(marker);
    try { return visible(source); }
    finally { if (marked) card.setAttribute(marker, ''); }
  }
  function restore(card) {
    card.removeAttribute(marker);
    const record = records.get(card);
    if (record) record.component.remove();
    for (const child of [...card.children]) if (child.matches(owned)) child.remove();
    records.delete(card);
  }
  function build(rows, source) {
    const component = document.createElement('dl');
    component.className = 'pmv-preorder-dates';
    component.setAttribute('data-pmv-preorder-dates', '');
    component.style.color = getComputedStyle(source).color;
    for (const [label, value] of rows) {
      const row = document.createElement('div');
      row.className = 'pmv-preorder-dates__row';
      const term = document.createElement('dt');
      term.className = 'pmv-preorder-dates__label';
      term.textContent = label;
      const detail = document.createElement('dd');
      detail.className = 'pmv-preorder-dates__value';
      detail.textContent = value;
      row.append(term, detail);
      component.append(row);
    }
    return component;
  }
  function update(card) {
    if (!matchesProduct(card)) { restore(card); return; }
    const reserved = card.matches('[data-pmv-stoq-info]');
    const reservedSources = reserved ? card.querySelectorAll(':scope > .pmv-stoq-reserved__dates') : null;
    const details = reserved ? (reservedSources.length === 1 ? reservedSources[0] : null) : card.querySelector(':scope > .preorder-description-details');
    const items = reserved ? null : details?.querySelectorAll(':scope > .preorder-detail-item');
    const source = reserved ? details : items?.length === 1 ? items[0].querySelector(':scope > .preorder-detail-text') : null;
    const complete = reserved || (source && items[0].textContent.trim() === source.textContent.trim() && details.textContent.trim() === source.textContent.trim());
    const selected = selectedProductVariant(card.closest('.product__info-container'));
    const values = source && source.children.length === 0 && complete ? resolveDates(source.textContent, copy.dateProjection, selected) : null;
    const rows = values ? [[copy.releaseLabel, values[0]], [copy.shippingLabel, values[1]]] : null;
    if (!rows || !originalVisible(card, source)) { restore(card); return; }
    const signature = JSON.stringify([selected, source.textContent, rows]);
    const prior = records.get(card);
    if (prior && prior.source === source && prior.details === details && prior.signature === signature && prior.component.parentElement === card) {
      const color = getComputedStyle(source).color;
      if (prior.component.style.color !== color) prior.component.style.color = color;
      return;
    }
    restore(card);
    let component;
    try {
      component = build(rows, source);
      card.insertBefore(component, details);
      const values = [...component.querySelectorAll('dd')].map(node => node.textContent);
      if (component.parentElement !== card || values.length !== rows.length || values.some((value, index) => value !== rows[index][1])) throw new Error('Date presentation incomplete');
      records.set(card, { component, source, details, signature });
      card.setAttribute(marker, '');
    } catch (_) {
      component?.remove();
      restore(card);
    }
  }
  function restoreInformation(context) {
    information.get(context)?.component.remove();
    information.delete(context);
    for (const component of context.querySelectorAll('[data-pmv-preorder-information]')) component.remove();
  }
  function restoreInformationProperties(form) {
    for (const input of form.querySelectorAll('[' + informationProperty + ']')) input.remove();
    informationForms.delete(form);
  }
  function updateInformationProperties(context) {
    const form = context.querySelector('.product__buy-buttons > product-form > form[data-type="add-to-cart-form"]');
    if (!form) return;
    const selected = selectedProductVariant(context);
    const state = guard.initial.productVariants.find(row => String(row.variantId || '').split('/').pop() === selected);
    const submit = form.querySelector('button[name="add"][type="submit"]');
    const nativeAction = [...context.querySelectorAll('.restock-rocket-preorder-button')].some(visible);
    const dates = copy.dateProjection;
    const values = selected && productVariants.has(selected) && dates?.taggedPreorder === true ? resolveDates('', dates, selected) : null;
    const names = ['Release Date', 'Estimated Shipping Date', '_pmv_preorder_information_version', '_pmv_preorder_information_source', '_pmv_preorder_information_variant'];
    const foreignProperty = [...form.querySelectorAll('input[name^="properties["]')].some(input =>
      !input.hasAttribute(informationProperty) && (names.some(name => input.name === 'properties[' + name + ']') || input.name.startsWith('properties[_stoq_')));
    if (!values || state?.stoqActive !== false || state.availableForSale !== true || !submit || submit.disabled || !visible(submit) || nativeAction || foreignProperty) {
      restoreInformationProperties(form);
      return;
    }
    const properties = [values[0], values[1], '1', 'shopify-canonical-date-metafields', selected];
    for (let index = 0; index < names.length; index++) {
      const name = 'properties[' + names[index] + ']';
      let input = [...form.querySelectorAll('[' + informationProperty + ']')].find(input => input.name === name);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.setAttribute(informationProperty, '');
        form.append(input);
      }
      if (input.value !== properties[index]) input.value = properties[index];
    }
    informationForms.add(form);
  }
  function refreshInformationSubmit(event) {
    const context = event.target?.closest?.('.product__info-container');
    if (!context || !root.contains(context)) return;
    try { updateInformationProperties(context); }
    catch (_) {
      for (const form of context.querySelectorAll('form')) restoreInformationProperties(form);
    }
  }
  function updateInformation(context) {
    const selected = selectedProductVariant(context);
    const dates = copy.dateProjection;
    const values = selected && productVariants.has(selected) && dates?.taggedPreorder === true ? resolveDates('', dates, selected) : null;
    const nativeDates = [...context.querySelectorAll('[data-pmv-preorder-dates]:not([data-pmv-preorder-information])')].some(visible);
    const form = context.querySelector('.product__buy-buttons > product-form > form[data-type="add-to-cart-form"]');
    const anchor = form?.querySelector(':scope > .product-form__buttons > .product-form__buttons-row');
    const target = anchor?.parentElement;
    if (!values || nativeDates || !target || !visible(target)) { restoreInformation(context); return; }
    const signature = JSON.stringify([selected, values]);
    const prior = information.get(context);
    if (prior && prior.signature === signature && prior.component.parentElement === target && prior.component.previousElementSibling === anchor) return;
    restoreInformation(context);
    const component = build([[copy.releaseLabel, values[0]], [copy.shippingLabel, values[1]]], target);
    component.classList.add('pmv-preorder-information');
    component.setAttribute('data-pmv-preorder-information', '');
    component.dataset.variantId = selected;
    anchor.insertAdjacentElement('afterend', component);
    information.set(context, { component, signature });
  }
  function reconcile() {
    frame = 0;
    if (stopped) return;
    for (const card of records.keys()) if (!card.isConnected || !root.contains(card)) restore(card);
    for (const card of root.querySelectorAll(selector)) {
      try { update(card); }
      catch (_) { restore(card); }
    }
    for (const context of information.keys()) if (!context.isConnected || !root.contains(context)) restoreInformation(context);
    for (const form of informationForms) if (!form.isConnected || !root.contains(form)) restoreInformationProperties(form);
    for (const context of root.querySelectorAll('.product__info-container')) {
      try { updateInformation(context); }
      catch (_) { restoreInformation(context); }
      try { updateInformationProperties(context); }
      catch (_) {
        for (const form of context.querySelectorAll('form')) restoreInformationProperties(form);
      }
    }
  }
  function schedule() {
    if (!stopped && !frame) frame = requestAnimationFrame(reconcile);
  }
  function insidePresentation(node) {
    const element = node?.nodeType === 1 ? node : node?.parentElement;
    return !!element?.closest(presentations);
  }
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => {
      if (insidePresentation(mutation.target)) return false;
      if (mutation.type !== 'childList') return true;
      const changed = [...mutation.addedNodes, ...mutation.removedNodes];
      return mutation.removedNodes.length > 0 || !changed.length || !changed.every(node => node.nodeType === 1 && node.matches(presentations));
    })) schedule();
  });
  observer.observe(root, { childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['hidden', 'style', 'class', 'aria-hidden', 'value', 'name', 'form', 'action', 'disabled'] });
  root.addEventListener('change', schedule, true);
  root.addEventListener('submit', refreshInformationSubmit, true);
  window.PMVPreorderDatesLayout = {
    refresh: schedule,
    destroy() {
      stopped = true;
      cancelAnimationFrame(frame);
      observer.disconnect();
      root.removeEventListener('change', schedule, true);
      root.removeEventListener('submit', refreshInformationSubmit, true);
      for (const card of [...records.keys()]) restore(card);
      for (const context of [...information.keys()]) restoreInformation(context);
      for (const form of [...informationForms]) restoreInformationProperties(form);
      delete window.PMVPreorderDatesLayout;
    }
  };
  schedule();
})();

